export const SET_CONFLUENCE_DOCUMENT_LINKS =
    "tenants/GET_CONFLUENCE_DOCUMENT_LINKS";

export interface ConfluenceLinks {
    machineLearningArticleUri: string;
    customFieldsConfiguration: string;
    featuresAndSettingsOverview: string;
    bankAccountValidation: string;
    recurringInvoices: string;
}

export interface MicrosoftLinks {
    serviceProtectionApiLimits: string;
}

export interface GetConfluenceDocumentLinks {
    type: typeof SET_CONFLUENCE_DOCUMENT_LINKS;
    confluenceDocumentLinks: ConfluenceLinks;
}

export interface State {
    confluenceDocumentLinks: ConfluenceLinks;
    isConfluenceDocumentLinksFetched: boolean;
}

export type Actions = GetConfluenceDocumentLinks;
